import React, { useState } from "react";
import { Link } from "react-router-dom";
const faqsData = [
    {
        question: "IIT GATE",
        answers: [
            { label: "IIT GATE 2026", link: "/courses/iit-gate2026" },
            { label: "IIT GATE 2027", link: "/courses/iit-gate2027" }
        ]
    },
    {
        question: "IIT JAM",
        answers: [
            { label: "IIT JAM 2026", link: "/courses/iit-jam2026" },
            { label: "IIT JAM 2027", link: "/courses/iit-jam2027" }
        ]
    }
];

function CourseTestimonial (){
    const [activeIndex, setActiveIndex] = useState(0);
    const toggleFAQ = (index) => {
        setActiveIndex(prev => (prev === index ? null : index));
    };
    return (
        <div className="leftbar">
            <div className="filterbox">
                <h3><i className="bi bi-filter"></i> Filter By</h3>
            </div>
            <div className="leftbarinner">
                <section className="faq_area">
                    <div className="faq_wrapper">
                        {faqsData.map((faq, index) => (
                            <div key={index} className="faq_item">
                                <div className={`faq_title ${activeIndex === index ? "active" : ""}`} onClick={() => toggleFAQ(index)}>
                                    {faq.question}
                                    <span className="arrow"><i className="bi bi-book-half"></i></span>
                                </div>
                                {activeIndex === index && (<div className="faq_details"><ul className="faq_links">{faq.answers.map((item, i) => (<li key={i}><Link to={item.link}>{item.label}</Link></li>))}</ul></div>)}
                            </div>
                        ))}
                    </div>
                </section>
            </div>
            <div className="filterbox1">
                <h3>Other</h3>
            </div>
        </div>
    );
}
export default CourseTestimonial;